import _ from 'lodash';
import { dateFormatter } from './helpers.js';

function lessThenHalf(arr, index) {
  return index + 1 <= arr.length / 2;
}

export default function initWeeklyBars() {
  const config = (graphEl, since, period) => ({
    chart: {
      toolbar: {
        show: false,
      },
      height: 150,
      width: '100%',
      offsetY: 5,
      type: 'area',
      events: {
        mouseMove: _.throttle(() => {
          const crosshairs = graphEl.querySelector('.apexcharts-xcrosshairs');
          const marker = graphEl.querySelector('.apexcharts-marker');
          const settings = { attributes: true };
          const observer = new MutationObserver(() => {
            crosshairs.setAttribute('y1', `${marker.cy.baseVal.value + marker.r.baseVal.value + 1}`);
          });

          observer.observe(marker, settings);
        }, 250),
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 3,
    },
    markers: {
      colors: ['#33323D'],
      strokeColors: '#02C3B5',
      strokeWidth: 4,
    },
    colors: ['#00c3b5'],
    fill: {
      colors: ['#00c3b5'],
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'horizontal',
        shadeIntensity: 0.5,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 100],
        colorStops: [{
          offset: 0,
          color: '#2d8e87',
        }, {
          offset: 50,
          color: '#02625b',
        }, {
          offset: 100,
          color: '#04615b',
        }],
      },
    },
    tooltip: {
      enabled: true,
      x: {
        show: false,
      },
      custom: ({
        series, seriesIndex, dataPointIndex, w,
      }) => (`
            <div class="card-tooltip-box ${lessThenHalf(series[0], dataPointIndex) ? 'left-side' : ''}">
              <div class="tooltip-box">
                <p class="light tooltip-title">Malware info</p>
                <div class="tooltip-box__subfield">
                  <p>Number of tasks</p>
                  <p class="light">${series[seriesIndex][dataPointIndex]}</p>
                </div>
                <div class="tooltip-box__subfield">
                  <p>Date</p>
                  <p class="light">${dateFormatter(since, period, dataPointIndex)}</p>
                </div>
              </div>
              <div class="tooltip-box-bg"></div>
            </div>`),
    },
    series: [{
      name: 'Task',
    }],
    grid: {
      show: false,
      padding: {
        left: 0,
        right: 0,
      },
    },
    legend: {
      show: false,
    },
    yaxis: {
      show: false,
      floating: true,
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        show: false,
      },
    },
    xaxis: {
      show: false,
      floating: true,
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
      },
      crosshairs: {
        position: 'front',
        stroke: {
          color: '#02C3B5',
        },
        opacity: 1,
      },
      tooltip: {
        enabled: false,
      },
    },
    responsive: [
      {
        breakpoint: 767,
        options: {
          events: {
            mouseMove: undefined,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    ],
  });
  const period = $('#period').val();

  $('.bar').each((ind, elem) => {
    const $bar = $(elem);
    const weekStatistics = $bar.text().trim().split(',');
    const sinceDate = $bar.data('since');

    const options = {
      ...config($bar.parent()[0], sinceDate, period),
      ...{
        series: [{
          data: weekStatistics,
        }],
      },
    };

    const observerCallback = (entries, observer) => {
      if (!entries[0].isIntersecting) {
        return;
      }

      const chart = new ApexCharts($bar.parent()[0], options);
      chart.render();
      observer.disconnect();
    };

    setTimeout(() => {
      const observer = new IntersectionObserver(observerCallback, { threshold: 1 });
      observer.observe(elem.parentElement);
    }, 2000);
  });
}
